// extracted by mini-css-extract-plugin
export default {"root":"root_root__7y8HR","fromIos":"root_fromIos__rZjkO","ios-12":"root_ios-12__0mgXY","details":"root_details__Pn85E","shrink":"root_shrink__zSHmm"};